const FETCH_SEEKER_LEADS = 'leads/seekerLeads/FETCH_SEEKER_LEADS';
const FETCH_SEEKER_LEADS_SUCCEEDED = 'leads/seekerLeads/FETCH_SEEKER_MESSAGES_SUCCEEDED';
const FETCH_SEEKER_LEADS_FAILED = 'leads/seekerLeads/FETCH_SEEKER_MESSAGES_FAILED';
const SET_SEEKER_LEADS_ORDER = 'leads/seekerLeads/SET_SEEKER_LEADS_ORDER';
const SET_SEEKER_LEADS_OFSET = 'leads/seekerLeads/SET_SEEKER_LEADS_OFSET';
const FETCH_SEEKER_LEADS_MOBILE = 'leads/seekerLeads/FETCH_SEEKER_LEADS_MOBILE';
const FETCH_SEEKER_LEADS_SUCCEEDED_MOBILE = 'leads/seekerLeads/FETCH_SEEKER_LEADS_SUCCEEDED_MOBILE';
const FETCH_SEEKER_LEADS_FAILED_MOBILE = 'leads/seekerLeads/FETCH_SEEKER_LEADS_FAILED_MOBILE';
const FETCH_SEEKER_MOBILE_SUCCEEDED_UPDATE_EVENT = 'leads/seekerLeads/FETCH_SEEKER_MOBILE_SUCCEEDED_UPDATE_EVENT';
const FETCH_SEEKER_LEADS_SUCCEEDED_MOBILE_SORTED = 'leads/seekerLeads/FETCH_SEEKER_MOBILE_SUCCEEDED_SORTED';

export {
  FETCH_SEEKER_LEADS,
  FETCH_SEEKER_LEADS_SUCCEEDED,
  FETCH_SEEKER_LEADS_FAILED,
  SET_SEEKER_LEADS_ORDER,
  SET_SEEKER_LEADS_OFSET,
  FETCH_SEEKER_LEADS_MOBILE,
  FETCH_SEEKER_LEADS_SUCCEEDED_MOBILE,
  FETCH_SEEKER_LEADS_FAILED_MOBILE,
  FETCH_SEEKER_MOBILE_SUCCEEDED_UPDATE_EVENT,
  FETCH_SEEKER_LEADS_SUCCEEDED_MOBILE_SORTED
};
